import { render, staticRenderFns } from "./vessels-reports-detail-modal.vue?vue&type=template&id=2a9f969a&scoped=true"
import script from "./vessels-reports-detail-modal.vue?vue&type=script&lang=js"
export * from "./vessels-reports-detail-modal.vue?vue&type=script&lang=js"
import style0 from "./vessels-reports-detail-modal.vue?vue&type=style&index=0&id=2a9f969a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9f969a",
  null
  
)

export default component.exports